import { PayableInvoice } from "../../api/queries";

/** Calendar day of an ISO timestamp, for date-only comparisons. */
const dayOf = (iso: string | null): string | null =>
  iso ? iso.split("T")[0] : null;

/**
 * Narrow paid invoices to a payment-date range.
 *
 * Bounds are inclusive and compared as calendar days, so an invoice paid at
 * any time on the "to" date still counts — comparing raw timestamps would
 * drop everything after midnight on the final day.
 *
 * An empty bound means unbounded on that side.
 */
export const filterByPaymentDate = (
  invoices: PayableInvoice[],
  from: string,
  to: string,
): PayableInvoice[] =>
  invoices.filter((invoice) => {
    const paidDay = dayOf(invoice.paid_at);
    if (!paidDay) return false;
    if (from && paidDay < from) return false;
    if (to && paidDay > to) return false;
    return true;
  });
